export default __webpack_public_path__ + "static/media/bg_img_desktop.fe29434f.png";